import { Injectable, signal } from '@angular/core';

type PdfSource = Blob | Uint8Array | ArrayBuffer | null;

@Injectable({
  providedIn: 'root'
})
export class ViewPdfService {
  pdfSource = signal<PdfSource>(null);
  pdfName = signal<string | null>(null);

  setPdfBytes(source: ArrayBuffer | Uint8Array | Blob, name?: string): void {
    if (source instanceof Blob && source.type !== 'application/pdf') {
      this.pdfSource.set(new Blob([source], { type: 'application/pdf' }));
    } else {
      this.pdfSource.set(source);
    }
    if (name) this.pdfName.set(name);
  }

  clear() {
    this.pdfSource.set(null);
    this.pdfName.set(null);
  }
}
